var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"id":"alerts-list-page","title":_vm.translate('Alerts'),"status":_vm.page_status,"waiting":_vm.waiting},on:{"statused":_vm.statused}},[_c('alerts-list',{attrs:{"topic-type":"*","topic-id":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }